var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"overflow-auto",attrs:{"max-height":"400"}},[_c('v-card-text',[_c('VueShowdown',{staticClass:"pa-2",attrs:{"markdown":_vm.value,"flavor":"github","options":{ emoji: true }}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }